<script>
  import { GroupPortholes } from '@client/components/group-portholes';
  import { SenderPortholes } from '@client/components/sender-portholes';

  import { GROUP_TYPES } from '@client/enums';

  export let row = {};

  $: hasSenders = row?.senders?.length;
  $: hasGroups = Object.keys(GROUP_TYPES).some((type) => row[type]?.length);
</script>

<div class="d-flex align-items-center gap-3">
  {#if hasSenders}
    <SenderPortholes data={row} />
  {/if}

  {#if hasGroups}
    {#each Object.keys(GROUP_TYPES) as type}
      {#if row[type].length}
        <GroupPortholes
          bind:data={row}
          {type}
          nameField={GROUP_TYPES[type].name}
          countField={GROUP_TYPES[type].count}
        />
      {/if}
    {/each}
  {/if}
</div>
